import { render, staticRenderFns } from "./toolbarLinks.vue?vue&type=template&id=64d60de1&"
import script from "./toolbarLinks.vue?vue&type=script&lang=js&"
export * from "./toolbarLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports